export default "__VITE_ASSET__DkLlDUSn__"